// MOMERY CUSTOM — Printess pricing field integration.
(function (root) {
    if (root.FacPrintessPricingFields) return;

    const FAC_SELECTED_OPTIONS_PROPERTY = '_fac_printess_selected_options';
    const REGISTER_RETRY_INTERVAL_MS = 250;
    const REGISTER_TIMEOUT_MS = 10000;

    function normalizePriceRelevantFields(response) {
        const fields = response?.formFields;

        if (!fields || typeof fields !== 'object') {
            return {};
        }

        return Object.entries(fields).reduce((selectedOptions, [fieldName, fieldData]) => {
            const value = fieldData?.value;

            if (typeof fieldName !== 'string' || fieldName.trim() === '') {
                return selectedOptions;
            }

            if (value === null || value === undefined) {
                return selectedOptions;
            }

            if (typeof value === 'string' && value.trim() === '') {
                return selectedOptions;
            }

            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                selectedOptions[fieldName.trim()] = String(value).trim();
            }

            return selectedOptions;
        }, {});
    }

    function readSelectedOptions(api) {
        if (!api || typeof api.getAllPriceRelevantFormFieldsExt !== 'function') {
            return null;
        }

        let fields;

        try {
            fields = api.getAllPriceRelevantFormFieldsExt();
        } catch (error) {
            console.warn('[FAC_CART_PRICING] Unable to read Printess pricing fields');
            return null;
        }

        if (!fields || typeof fields !== 'object') {
            return null;
        }

        return normalizePriceRelevantFields(fields);
    }

    function attachSelectedOptions(context, params) {
        const propertyValues = params?.propertyValuesToWrite;

        if (!propertyValues || Array.isArray(propertyValues) || typeof propertyValues !== 'object') {
            return false;
        }

        const api = context?.integration?.getApi?.() || null;
        const selectedOptions = readSelectedOptions(api);

        if (selectedOptions === null) {
            delete propertyValues[FAC_SELECTED_OPTIONS_PROPERTY];
            return false;
        }

        propertyValues[FAC_SELECTED_OPTIONS_PROPERTY] = JSON.stringify(selectedOptions);
        return true;
    }

    function registerPlugin() {
        if (root.__facPrintessPricingFieldsPluginRegistered) return true;
        if (typeof root.registerPrintessPlugin !== 'function') return false;

        root.registerPrintessPlugin({
            doAllowAddToBasketAsync(context, params) {
                const facProductForm = root.document?.querySelector?.(
                    'product-form[data-fac-enable-configuration-surcharges="true"]'
                );

                if (facProductForm) {
                    attachSelectedOptions(context, params);
                }

                return Promise.resolve();
            },
        });

        root.__facPrintessPricingFieldsPluginRegistered = true;
        return true;
    }

    root.FacPrintessPricingFields = {
        FAC_SELECTED_OPTIONS_PROPERTY,
        attachSelectedOptions,
        normalizePriceRelevantFields,
        readSelectedOptions,
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = root.FacPrintessPricingFields;
        return;
    }

    if (registerPlugin()) return;

    const startedAt = Date.now();
    const retryTimer = root.setInterval(() => {
        if (registerPlugin() || Date.now() - startedAt >= REGISTER_TIMEOUT_MS) {
            root.clearInterval(retryTimer);
        }
    }, REGISTER_RETRY_INTERVAL_MS);
})(typeof window !== 'undefined' ? window : globalThis);
